// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kO8eD","dateStyle":"styles_dateStyle__UkBYK"};